export default {
    name: 'lazy',

    hooks: {
        app: {
            loadAppData(data, registry) {
                if (registry.MixinPage === 'complete') {
                    this.lazy.activateAll(data.page.instance.el);
                    this.lazy.observeAll(data.page.instance.el);

                    return 'complete';
                }
                return 'wait';
            },
        },
    },

    methods: {
        app: {
            observeAll(elParent) {
                ['src', 'background-image'].forEach((action) => {
                    let method = this.string.toCamel('activate-' + action);

                    // Images
                    elParent
                        .querySelectorAll(`[data-lazy-${action}]`)
                        .forEach((el) => {
                            this.lazy.observeEl(el, (entry, observer) => {
                                if (entry.isIntersecting) {
                                    this.lazy[method](el);

                                    el.classList.remove('lazy-waiting');

                                    observer.unobserve(el);
                                }
                            });
                        });
                });
            },

            observeEl(el, onEvent) {
                let observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => onEvent(entry, observer));
                    },
                    { threshold: [0] }
                );

                el.classList.add('lazy-waiting');

                observer.observe(el);
            },

            activateAll(el) {
                this.lazy.activateBackgroundImages(el);
                this.lazy.loadLazyImages(el);
            },

            loadLazyImages(elParent) {
                elParent
                    .querySelectorAll('[data-lazy-image]')
                    .forEach((el) => this.lazy.loadLazyImage(el));
            },

            loadLazyImage(el) {
                el.setAttribute('src', el.getAttribute('data-lazy-image'));
                el.removeAttribute('data-lazy-image');
                el.classList.remove('waiting-load');
            },

            activateBackgroundImages(elParent) {
                elParent
                    .querySelectorAll('[data-lazy-background-image]')
                    .forEach((el) => this.lazy.activateBackgroundImage(el));
            },

            /**
             * Use image URL passed as data attribute as background image for specified element
             *
             * This as responsive parameters, allowing you to define different pictures depending
             * on the breaking point. It follows Bootstrap naming convention.
             *
             * @param el
             */
            activateBackgroundImage(el) {
                let screenWidth = window.innerWidth;
                let backgroundImageUrl = el.getAttribute(
                    'data-lazy-background-image'
                );
                let backgroundImageUrlXS = el.getAttribute(
                    'data-lazy-background-image-xs'
                );
                let backgroundImageUrlSM = el.getAttribute(
                    'data-lazy-background-image-sm'
                );
                let backgroundImageUrlMD = el.getAttribute(
                    'data-lazy-background-image-md'
                );
                let backgroundImageUrlLG = el.getAttribute(
                    'data-lazy-background-image-lg'
                );
                let backgroundImageUrlXL = el.getAttribute(
                    'data-lazy-background-image-xl'
                );

                if (screenWidth <= 576 && backgroundImageUrlXS) {
                    el.style.backgroundImage = `url("${encodeURI(
                        backgroundImageUrlXS
                    )}")`;
                } else if (screenWidth <= 768 && backgroundImageUrlSM) {
                    el.style.backgroundImage = `url("${encodeURI(
                        backgroundImageUrlSM
                    )}")`;
                } else if (screenWidth <= 992 && backgroundImageUrlMD) {
                    el.style.backgroundImage = `url("${encodeURI(
                        backgroundImageUrlMD
                    )}")`;
                } else if (screenWidth <= 1200 && backgroundImageUrlLG) {
                    el.style.backgroundImage = `url("${encodeURI(
                        backgroundImageUrlLG
                    )}")`;
                } else if (screenWidth > 1200 && backgroundImageUrlXL) {
                    el.style.backgroundImage = `url("${encodeURI(
                        backgroundImageUrlXL
                    )}")`;
                } else {
                    el.style.backgroundImage = `url("${encodeURI(
                        backgroundImageUrl
                    )}")`;
                }
                el.removeAttribute('data-lazy-background-image');
                el.removeAttribute('data-lazy-background-image-xs');
                el.removeAttribute('data-lazy-background-image-sm');
                el.removeAttribute('data-lazy-background-image-md');
                el.removeAttribute('data-lazy-background-image-lg');
                el.removeAttribute('data-lazy-background-image-xl');
            },

            activateSrc(el) {
                el.setAttribute('src', el.getAttribute('data-lazy-src'));
                el.removeAttribute('data-lazy-src');
            },
        },
    },
};
